import React from 'react';

/**
 * Shows image while loading
 */
const Loader = () => (
  <>
    <img
      src="https://static.toiimg.com/photo/70446270.cms"
      alt=""
      className="mediaWireLoader"
    />
  </>
);

export default Loader;
